import { LotteryComponent } from './../lottery/lottery.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DonateScreenComponent } from '../donate-screen/donate-screen.component';
import { SettingScreenComponent } from '../setting-screen/setting-screen.component';
import { ControllScreenComponent } from '../controll-screen/controll-screen.component';
import { WaitScreenComponent } from '../wait-screen/wait-screen.component';
import { RegisterScreenComponent } from '../register-screen/register-screen.component';
import { PlayScreenComponent } from '../play-screen/play-screen.component';
import { PlayVideoScreenComponent } from '../play-video-screen/play-video-screen.component';
import { PlayDonateComponent } from '../play-donate/play-donate.component';
import { OverviewComponent } from '../overview/overview.component';

const appRoutes: Routes = [
  { path: 'setting/:id', component: SettingScreenComponent },
  { path: 'donate/:id', component: DonateScreenComponent },
  { path: 'control/:id', component: ControllScreenComponent },
  { path: 'play/:id', component: PlayScreenComponent },
  { path: 'play-donate/:id', component: PlayDonateComponent },
  { path: 'play-video/:id', component: PlayVideoScreenComponent },
  { path: 'wait/:uid/:id', component: WaitScreenComponent },
  { path: 'wait/:uid', component: WaitScreenComponent },
  { path: 'overview/:id' , component: OverviewComponent },
  { path: 'lottery/:id' , component: LotteryComponent },
  { path: 'register' , component: RegisterScreenComponent },
  { path: '**' , component: RegisterScreenComponent },

  // https below
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
